import { UPDATE_TOPICS } from "../actionTypes";

const INITIAL_STATE = {};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case UPDATE_TOPICS:
      return { ...state, ...action.payload.entities.topics };
    default:
      return state;
  }
};

export default reducer;
